(function () {
function $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $554ed4b40b13e16f$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $e73bd16ec0b3c415$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}


"use strict";
var $197cd56b15c33885$var$contactForm = document.querySelector(".contact__form");
$197cd56b15c33885$var$contactForm === null || $197cd56b15c33885$var$contactForm === void 0 ? void 0 : $197cd56b15c33885$var$contactForm.addEventListener("submit", function(event) {
    event.preventDefault();
    $197cd56b15c33885$var$contactForm.reset();
});
var $197cd56b15c33885$var$SLIDER_ANIMATION_DURATION = 450;
function $197cd56b15c33885$var$initSlider(param) {
    var sliderSelector = param.sliderSelector, slideSelector = param.slideSelector, _param_activeClass = param.activeClass, activeClass = _param_activeClass === void 0 ? "is-active" : _param_activeClass, nextButtonSelector = param.nextButtonSelector, prevButtonSelector = param.prevButtonSelector, counterSelector = param.counterSelector, _param_enableClick = param.enableClick, enableClick = _param_enableClick === void 0 ? true : _param_enableClick, _param_enableSwipe = param.enableSwipe, enableSwipe = _param_enableSwipe === void 0 ? true : _param_enableSwipe;
    var slider = document.querySelector(sliderSelector);
    if (!slider) return;
    var slides = Array.from(slider.querySelectorAll(slideSelector));
    if (slides.length === 0) return;
    var nextButton = nextButtonSelector ? document.querySelector(nextButtonSelector) : null;
    var prevButton = prevButtonSelector ? document.querySelector(prevButtonSelector) : null;
    var counter = counterSelector ? document.querySelector(counterSelector) : null;
    var isActiveSlide = function(slide) {
        return slide.classList.contains(activeClass);
    };
    var activeIndex = slides.findIndex(isActiveSlide);
    if (activeIndex === -1) activeIndex = 0;
    var isAnimating = false;
    var startX = 0;
    var endX = 0;
    function updateCounter() {
        if (!counter) return;
        counter.textContent = String(activeIndex + 1).padStart(2, "0");
    }
    function setInitialSlide() {
        slides.forEach(function(slide, index) {
            slide.classList.toggle(activeClass, index === activeIndex);
        });
        updateCounter();
    }
    function showSlide(nextIndex) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $554ed4b40b13e16f$export$71511d61b312f219)(function() {
            var currentSlide, nextSlide;
            return (0, $e73bd16ec0b3c415$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isAnimating || nextIndex === activeIndex) return [
                            2
                        ];
                        isAnimating = true;
                        currentSlide = slides[activeIndex];
                        nextSlide = slides[nextIndex];
                        return [
                            4,
                            currentSlide.animate([
                                {
                                    opacity: 1
                                },
                                {
                                    opacity: 0
                                }
                            ], {
                                duration: $197cd56b15c33885$var$SLIDER_ANIMATION_DURATION,
                                easing: "ease-in-out"
                            }).finished
                        ];
                    case 1:
                        _state.sent();
                        currentSlide.classList.remove(activeClass);
                        nextSlide.classList.add(activeClass);
                        return [
                            4,
                            nextSlide.animate([
                                {
                                    opacity: 0
                                },
                                {
                                    opacity: 1
                                }
                            ], {
                                duration: $197cd56b15c33885$var$SLIDER_ANIMATION_DURATION,
                                easing: "ease-in-out"
                            }).finished
                        ];
                    case 2:
                        _state.sent();
                        activeIndex = nextIndex;
                        updateCounter();
                        isAnimating = false;
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function showNextSlide() {
        var nextIndex = activeIndex === slides.length - 1 ? 0 : activeIndex + 1;
        showSlide(nextIndex);
    }
    function showPrevSlide() {
        var prevIndex = activeIndex === 0 ? slides.length - 1 : activeIndex - 1;
        showSlide(prevIndex);
    }
    function handleSwipe() {
        var swipeDistance = endX - startX;
        var minSwipeDistance = 50;
        if (Math.abs(swipeDistance) < minSwipeDistance) return;
        if (swipeDistance < 0) showNextSlide();
        else showPrevSlide();
    }
    nextButton === null || nextButton === void 0 ? void 0 : nextButton.addEventListener("click", showNextSlide);
    prevButton === null || prevButton === void 0 ? void 0 : prevButton.addEventListener("click", showPrevSlide);
    if (enableClick) slides.forEach(function(slide) {
        slide.addEventListener("click", showNextSlide);
    });
    if (enableSwipe) {
        slider.addEventListener("pointerdown", function(event) {
            startX = event.clientX;
        });
        slider.addEventListener("pointerup", function(event) {
            endX = event.clientX;
            handleSwipe();
        });
    }
    setInitialSlide();
}
$197cd56b15c33885$var$initSlider({
    sliderSelector: "#slider",
    slideSelector: ".features__card",
    nextButtonSelector: "#btnNext",
    prevButtonSelector: "#btnPrev",
    counterSelector: "#features__page-first",
    enableClick: false,
    enableSwipe: true
});
$197cd56b15c33885$var$initSlider({
    sliderSelector: "#sliderTop",
    slideSelector: ".benefits__item",
    enableClick: true,
    enableSwipe: true
});

})();
//# sourceMappingURL=kickstarter-landing.3dbdf2e5.js.map
